/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { EvidenceExportGipAltReportMutationRequest, EvidenceExportGipAltReportMutationResponse, EvidenceExportGipAltReportPathParams, EvidenceExportGipAltReport400, EvidenceExportGipAltReport404 } from "../models/EvidenceExportGipAltReport";

export function getEvidenceExportGipAltReportUrl(id: EvidenceExportGipAltReportPathParams["id"]) {
  const res = { method: 'POST', url: `/reports/gip-alt/report/${id}/evidence-export` as const }
  return res
}

/**
 * @summary Start evidence export
 * {@link /reports/gip-alt/report/:id/evidence-export}
 */
export async function evidenceExportGipAltReport(id: EvidenceExportGipAltReportPathParams["id"], data: EvidenceExportGipAltReportMutationRequest, config: Partial<RequestConfig<EvidenceExportGipAltReportMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<EvidenceExportGipAltReportMutationResponse, ResponseErrorConfig<EvidenceExportGipAltReport400 | EvidenceExportGipAltReport404>, EvidenceExportGipAltReportMutationRequest>({ method : "POST", url : getEvidenceExportGipAltReportUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}